import { MenuItem } from "@headlessui/react";

interface DropdownMenuItemProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

/**
 * An item to be placed inside a DropdownMenu.
 * Handles styling for active and disabled states.
 */
export default function DropdownMenuItem({
  onClick,
  children,
  disabled = false,
  ...rest
}: DropdownMenuItemProps) {
  return (
    <MenuItem disabled={disabled}>
      {({ focus }) => (
        <button
          onClick={onClick}
          disabled={disabled}
          {...rest}
          className={`${
            focus ? "bg-neutral-700 text-white" : "text-neutral-200"
          } ${
            disabled ? "cursor-not-allowed opacity-50" : ""
          } group flex w-full items-center rounded-md px-3 py-2 text-sm`}
        >
          {children}
        </button>
      )}
    </MenuItem>
  );
}
